import { Action } from 'redux';

export const GET_INVENTORY_ASSIGNED = 'report-inventory/GET_INVENTORY_ASSIGNED';
export const getInventoryAssigned = (data: SelectReportData) => ({
  type: GET_INVENTORY_ASSIGNED,
  payload: data,
});

export const SET_INVENTORY_ASSIGNED = 'report-inventory/SET_INVENTORY_ASSIGNED';
export const setInventoryAssigned = (data: ReadonlyArray<InventoryAssigned>) => ({
  type: SET_INVENTORY_ASSIGNED,
  payload: data,
});

// invenoty assigned
export const GET_INVENTORY_ASSIGNED_TILE = 'report-inventory/GET_INVENTORY_ASSIGNED_TILE';
export const getInventoryAssignedTile = (data: SelectReportData) => ({
  type: GET_INVENTORY_ASSIGNED_TILE,
  payload: data,
});

export const SET_INVENTORY_ASSIGNED_TILE = 'report-inventory/SET_INVENTORY_ASSIGNED_TILE';
export const setInventoryAssignedTile = (data: ReadonlyArray<any>) => ({
  type: SET_INVENTORY_ASSIGNED_TILE,
  payload: data,
});

export const GET_INVENTORY_BY_STACK = 'report-inventory/GET_INVENTORY_BY_STACK';
export const getInventoryByStack = (data: SelectReportData) => ({
  type: GET_INVENTORY_BY_STACK,
  payload: data,
});

export const SET_INVENTORY_BY_STACK = 'report-inventory/SET_INVENTORY_BY_STACK';
export const setInventoryByStack = (data: ReadonlyArray<InventoryByStack>) => ({
  type: SET_INVENTORY_BY_STACK,
  payload: data,
});
// for email
export const GET_CLIENT_MAIL = 'report-inventory/GET_CLIENT_MAIL';
export const getClinetMail = () => ({
  type: GET_CLIENT_MAIL,
});

export const SET_CLIENT_MAIL = 'report-inventory/SET_CLIENT_MAIL';
export const setClinetMail = (data: any) => ({
  type: SET_CLIENT_MAIL,
  payload: data,
});

export const SET_BULKCITATION_DATA = 'report-inventory/SET_BULKCITATION_DATA';
export const setBulkCitationData = (data: any) => ({
  type: SET_BULKCITATION_DATA,
  payload: data,
});

export interface SetInventoryAssignedAction extends Action<typeof SET_INVENTORY_ASSIGNED> {
  readonly payload: ReadonlyArray<InventoryAssigned>;
}

export interface SetInventoryAssignedTileAction extends Action<typeof SET_INVENTORY_ASSIGNED_TILE> {
  readonly payload: ReadonlyArray<any>;
}

export interface SetInventoryByStackAction extends Action<typeof SET_INVENTORY_BY_STACK> {
  readonly payload: ReadonlyArray<InventoryByStack>;
}

export interface SetClientMailAction extends Action<typeof SET_CLIENT_MAIL> {
  readonly payload: any;
}

export interface SetBulkCitationDataAction extends Action<typeof SET_BULKCITATION_DATA> {
  readonly payload: any;
}

export type ReportInventoryAction =
  | SetInventoryAssignedAction
  | SetInventoryByStackAction
  | SetInventoryAssignedTileAction
  | SetClientMailAction
  | SetBulkCitationDataAction;
